import {
    BASE_URL_API,
    BASE_URL_APP,
    clearHtmlFromString,
    formatDate, getCampaignDurationLabel,
} from '@/shared/functions/Functions';
import Image from 'next/image';
import Link from 'next/link';
import React from 'react';
import CardLayout from '@/shared/components/cards/CardLayout';
import {notFound} from 'next/navigation';

export const dynamic = 'force-dynamic';

type Params = Promise<{ uuid: string }>;

async function generateStaticParams(uuid: string) {
    const res = await fetch(`${BASE_URL_API}/public/campaign/${uuid}`);
    if (!res.ok) {
        notFound();
    }
    return res.json();
}

export async function generateMetadata(props: { params: Params }) {
    const campaign = await generateStaticParams((await props.params).uuid);

    return {
        title: campaign.title || 'Campaign Page',
        description: campaign.description || 'Explore our campaign details.',
        openGraph: {
            type: 'website',
            title: campaign.title,
            description: campaign.description,
            // images: campaign.campaignImages?.[0]?.path || '/default-image.jpg',
            images: [
                {
                    url: campaign.campaignImages?.[0]?.thumbnail || '/default-image.jpg',
                    // width: 1200,
                    // height: 630,
                    alt: campaign.title,
                },
            ],
        },
        twitter: {
            card: 'summary_large_image',
            title: campaign.title,
            description: campaign.description,
            images: campaign.campaignImages?.[0]?.path || '/default-image.jpg',
        },
    };
}

export default async function CampaignPage(props: { params: Params }) {
    const campaign = await generateStaticParams((await props.params).uuid);

    const isLongTermCampaign = campaign?.isLongTerm
    return (
        <div>
            <div style={{maxWidth: 640}} className='mx-auto mt-5 mb-4 position-relative overflow-hidden'>
                {isLongTermCampaign && (
                    <div className="diagonal-text">
                                <span>
                                  Long term
                                </span>
                    </div>
                )}
                <CardLayout classBody='p-0'>
                    <div className='text-center px-4 px-sm-5 pt-4'>
                        <h3 className='mb-4'>{campaign?.title}</h3>
                        <h6 className='text-primary'>{campaign?.brand?.name}</h6>
                        {/* <ImageHandler classes="rounded max-width-100 img-cover" photoPath={campaign?.campaignImages[0].path} altTag="campaign" /> */}
                        <Image
                            className='rounded max-width-100 img-cover'
                            src={campaign?.campaignImages[0].path}
                            alt='campaign'
                            layout='responsive'
                            width={300}
                            height={200}
                        />
                    </div>

                    <div className='px-4 px-sm-5 mt-5'>
                        <h6>
                            Campaign description
                             {/*{t('brand.campaign.briefing.campaign_desc')}*/}
                        </h6>
                        <p className='text-muted truncate-3'>
                            {clearHtmlFromString(campaign?.adDescription ?? '-')}
                        </p>
                    </div>

                    {isLongTermCampaign ?
                        <div className='d-flex justify-content-between mt-4'>
                            <div className='pl-4 pl-sm-5 pr-2'>
                                <h6>
                                    Start date
                                </h6>
                                <p className='text-muted truncate-3'>
                                    {formatDate(campaign?.date)}
                                </p>
                            </div>

                            <div className='pr-4 pr-sm-5 pl-2'>
                                <h6>
                                    Campaign duration
                                </h6>
                                <p className='text-muted truncate-3'>
                                    {campaign?.invoiceDuration ? getCampaignDurationLabel(campaign?.invoiceDuration) : '-'}
                                </p>
                            </div>

                        </div> :
                        <div className='d-flex justify-content-between mt-4'>
                            <div className='pl-4 pl-sm-5 pr-2'>
                                <h6>
                                    Application deadline
                                    {/* {t('brand.campaign.dashboard.app_deadline')} */}
                                </h6>
                                <p className='text-muted truncate-3'>
                                    {formatDate(campaign?.date)}
                                </p>
                            </div>

                            <div className='pr-4 pr-sm-5 pl-2'>
                                <h6>
                                    Publication period
                                    {/* {t('brand.campaign.dashboard.pub_period')} */}
                                </h6>
                                <p className='text-muted truncate-3'>
                                    {formatDate(campaign?.publishFrom)} -{' '}
                                    {formatDate(campaign?.publishTo)}
                                </p>
                            </div>
                        </div>
                    }
                    <div className='text-center'>
                        <Link
                            href={`${BASE_URL_APP}influencer/register/step/1`}
                            className='btn btn-primary'
                        >
                            Register now
                        </Link>
                        <div className='mt-2'>
              <span className='text-muted mr-2'>
                Already have a profile?
                  {/* {t('auth.already_have_profile')} */}
              </span>
                            <Link href={BASE_URL_APP}>Login</Link>
                        </div>
                    </div>

                    <div
                        className='pt-5 pb-4 text-center'
                        style={{
                            backgroundImage: `url('${BASE_URL_APP}/icons/emails/mail-shapes-3.png'), url('${BASE_URL_APP}/icons/emails/mail-shapes-2.png')`,
                            backgroundPosition: '-12px 0px, 100% 15px',
                            backgroundRepeat: 'no-repeat',
                        }}
                    >
                        <div>
                            <div className='text-muted'>influence.vision GmbH</div>
                            <div className='text-muted'>Vienna | Cologne | Bijeljina</div>
                            <div>
                                <a
                                    href='https://calendly.com/influencevision-support/support-influence-vision'
                                    target='_blank'
                                >
                                    Support
                                </a>
                            </div>
                            <div>
                                <a href='mailto:support@influencevision.com'>
                                    support@influencevision.com
                                </a>
                            </div>
                            <div>
                                <a href='https://www.influencevision.com/' target='_blank'>
                                    www.influencevision.com
                                </a>
                            </div>
                        </div>
                    </div>
                </CardLayout>
            </div>
        </div>
    );
}
